import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule,Routes,ExtraOptions  } from '@angular/router';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from "angular-datatables";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatExpansionModule} from '@angular/material/expansion';
import { HomeGridComponent } from './home/home-grid/home-grid.component';
import {MatTableModule} from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatDividerModule} from '@angular/material/divider';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import {MatSelectModule} from '@angular/material/select'; 
import { NewVulnerabilityComponent } from './new-vulnerability/new-vulnerability.component'; 
import {MatCardModule} from '@angular/material/card';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'; 
import {MatButtonModule} from '@angular/material/button';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import {MatToolbarModule} from '@angular/material/toolbar';
import { ErrorService } from './error.service';
import { ErrorComponent } from './error/error.component';
import {CellDataRenderComp} from './home/home-grid/CellDataRenderComp';
import{CellDataRenderComp_Assess} from './assessment/assessment-home/CellDataRenderComp_Assess'
import {HttpErrorService} from './error/httpError.service';
import { NewAssessmentComponent } from './assessment/new-assessment.component';

import { MsalModule, MsalRedirectComponent, MsalService, MSAL_INSTANCE } from '@azure/msal-angular'; // Updated import
import { PublicClientApplication,IPublicClientApplication } from '@azure/msal-browser';
import { DataResolverService } from './Data Service/data-resolver.service';
import { UserViewVulnerabilityComponent } from './user-view-vulnerability/user-view-vulnerability.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { AssessmentHomeComponent } from './assessment/assessment-home/assessment-home.component';
import { UserViewAssessmentComponent } from './assessment/user-view-assessment/user-view-assessment.component';
import { LoginErrorComponent } from './login-error/login-error.component';
//const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {MatDialogModule} from '@angular/material/dialog';
import { DialogueConfirmationComponent } from './Dialogue Confirmation/dialogue-confirmation/dialogue-confirmation.component';
import { AdminViewComponent } from './Admin/admin-view/admin-view.component';
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      
      //#region for PPD
      clientId: 'de4ea3ec-2d8a-418f-8574-3ccde63085d0',
      //authority: 'f3211d0e-125b-42c3-86db-322b19a65a22', 
      authority: 'https://login.microsoftonline.com/accentureaadsyncstage.onmicrosoft.com/',
      redirectUri: 'https://gccvmppd.accenture.com',
      postLogoutRedirectUri: "https://gccvmppd.accenture.com",
      //#endregion
      
      /***/
      //#region for Production
      // clientId: '007569c4-3db0-4b91-9672-5263efcf3f3a',
      // authority: 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb',
      // knownAuthorities:['https://login.microsoftonline.com'],
      // redirectUri: 'https://gccvm.accenture.com',
      // postLogoutRedirectUri: "https://gccvm.accenture.com",
      //#endregion
      
      navigateToLoginRequestUrl: true,
    }
  });
}

const appRouters:Routes=[
  // {path:'home',component:HomeGridComponent},
  // {path:'newvulnerability',component:NewVulnerabilityComponent},
  // {path:'',redirectTo:'/home',pathMatch:'full'}
  ];
@NgModule({
  declarations: [
    AppComponent,
    NewVulnerabilityComponent,
    HomeGridComponent,
    ErrorComponent,
    CellDataRenderComp,
    CellDataRenderComp_Assess,
    NewAssessmentComponent,
    UserViewVulnerabilityComponent,
    MaintenanceComponent,
    AssessmentHomeComponent,
    UserViewAssessmentComponent,
    LoginErrorComponent,
    DialogueConfirmationComponent,
    AdminViewComponent  
  ],
  imports: [
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRouters,{ useHash: true }),
    RouterModule.forRoot(appRouters),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatGridListModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    MatExpansionModule,
    DataTablesModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    Ng2SmartTableModule,                    
     MatSelectModule,
     MatCardModule,
     HttpClientModule,     
     MatMomentDateModule,
     MatToolbarModule,
     MatDialogModule,
     NgxMatSelectSearchModule,
     MsalModule.forRoot( new PublicClientApplication({
      auth: {
        
        //#region for PPD
        clientId: 'de4ea3ec-2d8a-418f-8574-3ccde63085d0',
        //authority: 'f3211d0e-125b-42c3-86db-322b19a65a22', 
         authority: 'https://login.microsoftonline.com/accentureaadsyncstage.onmicrosoft.com/v2.0',
         redirectUri: 'https://gccvmppd.accenture.com',
         postLogoutRedirectUri: "https://gccvmppd.accenture.com",
         //#endregion
         
        /*
        //#region for Production
        
        clientId: '007569c4-3db0-4b91-9672-5263efcf3f3a',
        authority: 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb',
        knownAuthorities:['https://login.microsoftonline.com'],
        // authority: 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb',
        redirectUri: 'https://gccvm.accenture.com',
        postLogoutRedirectUri: "https://gccvm.accenture.com",
        //#endregion
        **/
        navigateToLoginRequestUrl: true,
      },
      // cache: {
      //   cacheLocation: 'localStorage',
      //   //storeAuthStateInCookie: isIE,
      // }
    }), null, null)
  ],
  providers: [
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {provide: ErrorHandler,useClass: ErrorService,},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorService,
      multi: true
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory
  },
  MsalService,DataResolverService
  ],
  
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
